import { Injectable } from '@angular/core';
import { IBaseService } from '../../features/guided-order/base.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrintingOnType } from 'src/app/shared/enums/printing-on-type.enum';
import { EolctDataService } from 'src/app/shared/data-service/eolct-data.service';
import { CurrentOrderService } from 'src/app/shared/services/current-order.service';
import { ReportTemplate } from 'src/app/shared/models/report-template.model';
import { OrderDataService } from 'src/app/shared/data-service/order-data.service';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { TranslationService } from 'projects/dop-core/src/public-api';

@Injectable()
export class PrintSampleBarcodeService implements IBaseService {
  printingOnType = PrintingOnType;
  fb: FormGroup;
  reportTemplates: ReportTemplate[];
  currentOrder = this.currentOrderService.currentOrder;
  constructor(
    private eolctDataService: EolctDataService,
    private currentOrderService: CurrentOrderService,
    private orderDataService: OrderDataService) {
  }
  initiate(fb: FormBuilder): FormGroup {
    this.fb = fb.group({
      reportTemplate: '',
      printingOn: this.printingOnType.CONTAINING,
      noOfBarcode: ['1', [Validators.required, Validators.maxLength(3), Validators.pattern('^[0-9]*$'),
      RxwebValidators.range({ minimumNumber: 1, maximumNumber: 100 })]]
    });
    return this.fb;
  }

  getReportTemplates(): Promise<ReportTemplate[]> {
    return this.orderDataService.getReportTemplates(this.currentOrder.account.code).toPromise();
  }

  updateSampleCount(count: number) {
    this.fb.get('noOfBarcode').setValue(count);
    if (count < 1 || count > 100) {
      this.fb.get('noOfBarcode').setErrors({ range: true });
    } else {
      this.fb.get('noOfBarcode').setErrors(null);
    }
  }

  downloadSampleBarcodes(enableSmartLabelPrinting: boolean) {
    const noOfBarcode = (enableSmartLabelPrinting &&
      this.fb.get('printingOn').value === this.printingOnType.CONTAINING) ? this.fb.get('noOfBarcode').value : 0;
    return this.orderDataService
      .getSampleBarcode(this.currentOrder.OrderCode, this.currentOrder.printingServiceCode, noOfBarcode)
      .subscribe(x => {
        const newBlob = new Blob([x], { type: 'application/pdf' });
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = TranslationService.translate('vbeiSampleLabels');
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      });
  }
}
